import { render, staticRenderFns } from "./AffirmationDialog.vue?vue&type=template&id=4e8bd447"
import script from "./AffirmationDialog.vue?vue&type=script&lang=ts"
export * from "./AffirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./AffirmationDialog.vue?vue&type=style&index=0&id=4e8bd447&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@6.11.0_webpack@5.105.3__lodash@4_1f38f72e7d8f3eef61099422a8f9de15/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports